export default class CompatObjectFit {

	static init() {
		let hasObjectFit = "objectFit" in document.documentElement.style;
		let isEdge = window.navigator.userAgent.indexOf( "Edge" ) > 1;
		if ( !hasObjectFit ) {
			jQuery( document.documentElement ).addClass( "compat-object-fit" );
		} else if ( isEdge ) {
			jQuery( document.documentElement ).addClass( "compat-object-fit-video" );
		}
		if ( !hasObjectFit || isEdge ) {
			this.getElements().one( 'load', function () {
				CompatObjectFit.scaleElementToParent( jQuery( this ) );
			} );
			jQuery( window ).on( 'load theme:resize', function () {
				CompatObjectFit.getElements().each( function () {
					CompatObjectFit.scaleElementToParent( jQuery( this ) );
				} );
			} );
		}
	}

	static addElements( selector ) {
		if ( window.$themeCompatObjectFit instanceof jQuery ) {
			window.$themeCompatObjectFit = window.$themeCompatObjectFit.add( selector );
		} else {
			window.$themeCompatObjectFit = jQuery( selector );
		}
	}

	static getElements() {
		if ( window.navigator.userAgent.indexOf( "Edge" ) > 1 ) {
			return window.$themeCompatObjectFit.filter( ":not(img)" );
		} else if ( !("objectFit" in document.documentElement.style) ) {
			return window.$themeCompatObjectFit;
		}
		return jQuery();
	}

	static scaleElementToParent( $image, containImage ) {
		let parentWidth = $image.parent().outerWidth();
		let parentHeight = $image.parent().outerHeight();
		let imageProp = 1;
		if ( $image.is( 'canvas, video' ) ) {
			imageProp = $image.get( 0 ).width / $image.get( 0 ).height;
		} else {
			imageProp = $image.get( 0 ).naturalWidth / $image.get( 0 ).naturalHeight;
		}
		let isParentRatioLarger = (parentWidth / parentHeight) > imageProp;
		let reverseIfContain = isParentRatioLarger;
		if ( typeof containImage !== "undefined" && containImage === true ) {
			reverseIfContain = !isParentRatioLarger;
		}
		if ( $image.is( 'canvas' ) ) {
			if ( reverseIfContain ) {
				$image.css( {
					'width': "100.1%",
					'height': Math.ceil( parentWidth / imageProp ) + "px"
				} );
			} else {
				$image.css( {
					'width': Math.ceil( parentHeight * imageProp ) + "px",
					'height': "100.1%"
				} );
			}
		} else {
			if ( reverseIfContain ) {
				$image.css( { 'width': "100.1%", 'height': "auto" } );
			} else {
				$image.css( { 'width': "auto", 'height': "100.1%" } );
			}
		}
	}
}
